import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import * as _ from 'lodash';

class Duration extends PureComponent {
  getClassNames() {
    const classNames = ['duration'];

    classNames.push(`duration-as-${this.props.as}`);

    if (this.props.classNames) {
      classNames.push(this.props.classNames);
    }

    return classNames.join(' ');
  }

  getCleanedDurationISOString(duration) {
    let durationString = duration.toISOString();

    durationString = durationString.replace('P', '');
    durationString = durationString.replace('T', ' ');

    durationString = durationString.toLowerCase();

    return durationString;
  }

  getDurationString() {
    const { ms, as } = this.props;
    const duration = moment.duration(ms);

    switch (as) {
      case 'onlyDays':
        return `${_.floor(duration.asDays())}d`;
      case 'days':
        return `${_.floor(duration.asDays())}d${this.getTimeSuffix()}`;
      case 'hours':
        return this.getTimeString();
      default:
        return this.getCleanedDurationISOString(duration);
    }
  }

  getTimeSuffix() {
    const duration = moment.duration(this.props.ms);
    let timeSuffix = '';

    if (duration.hours() + duration.minutes() > 0) {
      timeSuffix += ' ';
      timeSuffix += this.getTimeString(true);
    }

    return timeSuffix;
  }

  getTimeString(isPartial = false) {
    const duration = moment.duration(this.props.ms);
    let timeString;

    // hours
    if (isPartial) {
      timeString = `0${duration.hours()}`.slice(-2);
    } else {
      timeString = `${duration.asHours()}`;
      if (timeString.length < 2) { `0${timeString}`.slice(-2); }
    }

    // separator
    timeString += ':';

    // minutes
    timeString += `0${duration.minutes()}`.slice(-2);

    return timeString;
  }

  render() {
    return (
      <span className={this.getClassNames()}>
        {this.getDurationString()}
      </span>
    );
  }
}

Duration.propTypes = {
  ms: PropTypes.number.isRequired,
  as: PropTypes.string.isRequired,
  classNames: PropTypes.string,
};

Duration.defaultProps = {
  classNames: null,
};

export default Duration;



// WEBPACK FOOTER //
// ./src/Shared/DateTime/Duration.js